import { useState } from "react";
import { Box, CircularProgress, Tab, Tabs, Typography } from "@mui/material";

import Layout from "../../templates/Layout";
import ListSearch from "../../Form/ListSearch";
import { useListRobotQuery } from "hooks/worker/useRobot";
import { CleaningRobotItem } from "types/response/robot";
import { RobotListTable } from "./RobotListTable";
import { PartsStateTable } from "./PartsStateTable";

export const RobotListPage = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const handleChangeTabIndex = (_: React.SyntheticEvent, newIndex: number) => {
    setTabIndex(newIndex);
  };
  const { data: robots = [], isLoading, error } = useListRobotQuery();

  // テーブルの行
  const [searchedRobots, setSearchedRobots] = useState<CleaningRobotItem[]>([]);
  // 検索バーに入力された文字
  const [searched, setSearched] = useState("");

  // リストが見つからなかったときのメッセージを生成
  const getMessageBySearchedList = (
    searchedList: CleaningRobotItem[],
    searchString: string
  ): string => {
    if (searchedList.length === 0 && searchString.length !== 0) {
      return "検索結果はありません";
    } else if (searchedList.length === 0 && searchString.length === 0) {
      return "ロボットはありません";
    } else {
      return "";
    }
  };

  if (isLoading) {
    return <CircularProgress />;
  }

  if (error) {
    return null;
  }

  return (
    <Layout title="ロボット一覧">
      <Box sx={{ mb: 1 }}>
        <ListSearch
          initialRows={robots}
          searched={searched}
          setRows={setSearchedRobots}
          setSearched={setSearched}
          columnGetters={[(robot) => robot.robotName]}
        />
      </Box>
      <Tabs value={tabIndex} onChange={handleChangeTabIndex}>
        <Tab label="ロボット一覧" />
        <Tab label="消耗品一覧" />
      </Tabs>
      {searchedRobots.length > 0 ? (
        <>
          {tabIndex === 0 && <RobotListTable robots={searchedRobots} />}
          {tabIndex === 1 && <PartsStateTable robots={searchedRobots} />}
        </>
      ) : (
        <Typography variant="h5" sx={{ margin: 4 }}>
          {getMessageBySearchedList(searchedRobots, searched)}
        </Typography>
      )}
    </Layout>
  );
};
